var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`paginationText ${_vm.cssClasses}`,attrs:{"id":`PaginationText_${_vm.context}`}},[_c('strong',[_vm._v(_vm._s(_vm.paginationText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }